/**
 * Stage 5C — layout route that owns CompanyBrandProvider.
 *
 * Mounted ONLY around the authenticated Company routes (`/this-month`,
 * `/inbox/*`, `/months/*`, `/capture`, `/accountant`, `/settings`, …).
 * NOT mounted on:
 *   - pre-auth surfaces (/welcome, /login, /register, /verify-email,
 *     /forgot-password, /landing, /onboarding, /choose-workspace)
 *   - invitation surfaces (/accountant-invitations/:token,
 *     /sponsorship-invitations/:token) — Stage 5B snapshot owns those.
 *   - employee shell (/e/*)
 *   - accountant workspace (/firm/*)
 *   - internal admin (/admin/*)
 *   - legal pages (/terms, /privacy)
 *
 * Behaviour:
 *   - When AuthProvider has not resolved user+company yet → render
 *     <Outlet/> WITHOUT mounting the provider. Pages render their own
 *     Ordly shell during bootstrap.
 *   - When user+company are present → mount CompanyBrandProvider with
 *     trusted session props. Provider receives identity from React
 *     state only — never from URL/query/cookie.
 */
import React from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { CompanyBrandProvider } from "../lib/companyBrand";
import CompanyBrandBridge from "./CompanyBrandBridge";

export default function CompanyAuthenticatedShell() {
    const { user, company } = useAuth();

    if (!user?.id || !company?.id) {
        return <Outlet />;
    }

    return (
        <CompanyBrandProvider user={user} company={company}>
            <CompanyBrandBridge>
                <Outlet />
            </CompanyBrandBridge>
        </CompanyBrandProvider>
    );
}
